module.exports = __webpack_public_path__ + "static/media/celo.a19b12c1.jpg";